import { render, staticRenderFns } from "./HelloHeart.vue?vue&type=template&id=51c78767&scoped=true&"
import script from "./HelloHeart.vue?vue&type=script&lang=ts&"
export * from "./HelloHeart.vue?vue&type=script&lang=ts&"
import style0 from "./HelloHeart.vue?vue&type=style&index=0&id=51c78767&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c78767",
  null
  
)

export default component.exports